import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { IngredientSearchDTO } from "utils/helpers/models/ingredients.dto";

interface Filters {
  name?: string;
  status?: boolean;
  offset?: number;
  limit?: number;
}

export const useIngredient = () => {
  const getIngredients = async (
    setData: React.Dispatch<React.SetStateAction<any[]>>,
    filters: Filters & { offset?: number; limit?: number },
    setIngredientPaginationState: Function
  ) => {
    // Filter out undefined fields from filters
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== "") {
        acc[key] = String(value); // Ensure all values are strings
      }
      return acc;
    }, {} as Record<string, string>);

    const queryParams = new URLSearchParams(filteredParams).toString();

    try {
      const res = await Apis.getIngredientsAllAndFiltered(queryParams);
      setData(res.data.ingredients);
      setIngredientPaginationState(res.data.pagination);
      return res.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };


  const getIngredientById = async (id: number | null, setData: any) => {
    await Apis.getIngredientById(id)
      .then((res) => {
        setData(res.data.ingredient);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const postIngredient = async (body: any) => {
    await Apis.postIngredient(body)
      .then((res) => {
        if (res.data.status) {
          dispatch(setModalClosed("Ingredient"));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const putIngredient = async (id: number, body: any) => {
    await Apis.putIngredient(id, body)
      .then((res) => {
        console.error(res);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const deleteIngredient = async (id: number) => {
    return Apis.deleteIngredient(id);
  };

  const searchIngredients = (data: IngredientSearchDTO) => {
    Apis.searchIngredients(data)
      .then((res) => console.error(res))
      .catch((err) => console.error(err));
  };
  return {
    getIngredients,
    postIngredient,
    getIngredientById,
    putIngredient,
    deleteIngredient,
    searchIngredients,
  };
};
